import Title from "../../../../components/Title/component";
import styles from "../../../../components/Title/styles/themes/default.module.scss";

type HighlightsProps = {
    list?: string[];
    heading?: string;
};
/**
 * Highlights component
 * This component renders the story highlights.
 *
 * @param {Object} props The component props
 * @returns {React.Component} Returns the Highlights component
 */
export function Highlights({ heading = "Latest", list }: HighlightsProps) {
    const highlightListing = getHighlightList(list);

    return (
        <div
            className={`highlights sclt-highlights ${styles.highlights}`}
            data-testid="highlights"
        >
            <span>
                <Title level="h2">
                    <span>{heading}</span>
                </Title>
            </span>
            <ul className="highlightList">{highlightListing}</ul>
        </div>
    );
}

function getHighlightList(list?: string[]) {
    if (list !== undefined && list.length) {
        return list.map((title) => (
            <li className="highlightListItem" key={title}>
                <span>{title}</span>
            </li>
        ));
    }
}

export default Highlights;
